import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import courseDefault from '../../assets/course.jpg';
import CardCorso from '../Card/Corso';
import CardPubblicazione from '../Card/Pubblicazione';


import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, FreeMode, Scrollbar, Navigation } from "swiper/modules";

import 'swiper/css';
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/navigation";



export default function UltimePubblicazioni() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);


    useEffect(() => {
        init()
    }, []);


    async function init() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.getItems('publication', 1, 1000, sorting)
        if (response.success === 1) {
            var t = response.body
            setData(t)
            console.warn('last publication', t)
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    if (data) {
        if (data.length) {
            return (
                <Container fluid className='p-0 mt-4 pb-5 course-slider' style={{ backgroundColor: '#f7f7f7' }}>
                    <Container fluid={'md'}>
                        <Row>
                            <Col>
                                <div className='text-center my-5'>
                                    <h3>Le ultime pubblicazioni</h3>
                                </div>

                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={30}
                                    freeMode={false}
                                    grabCursor={true}
                                    scrollbar={true}
                                    pagination={false}
                                    navigation={true}
                                    modules={[FreeMode, Pagination, Scrollbar, Navigation]}
                                    className="home-course-swiper"
                                >
                                    {data.map((item, j) => {
                                        var image = item.image ? ResourceManager.getFileUrl(item.image, 'course') : courseDefault
                                        return (
                                            <SwiperSlide key={j} style={{ "width": '340px' }}>
                                                <CardPubblicazione data={item}></CardPubblicazione>
                                            </SwiperSlide>
                                        )
                                    })}

                                </Swiper>
                            </Col>
                        </Row>


                    </Container>
                </Container>
            );
        }
        else {
            return <></>
        }
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};